import React from "react";
import { useNavigate } from "react-router-dom";
import { Reveal, LineReveal } from "@/lib/motion";

export const ClosingCTA = () => {
  const navigate = useNavigate();
  return (
    <section
      id="apply"
      data-testid="closing-section"
      className="relative border-t border-white/10 py-32 md:py-48 overflow-hidden"
    >
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(900px_circle_at_50%_-10%,rgba(255,255,255,0.05),transparent_70%)]" />
      <div className="max-w-[1100px] mx-auto px-6 md:px-12 flex flex-col items-center text-center">
        <h2 className="font-syne font-extrabold tracking-tightest text-4xl md:text-6xl lg:text-7xl leading-[0.95]">
          <LineReveal
            lines={["The roster is", <>intentionally <span className="font-cormorant italic font-light text-white/60">small.</span></>]}
            stagger={0.12}
          />
        </h2>
        <Reveal delay={0.2}>
          <p className="mt-8 text-lg md:text-xl text-white/55 font-light max-w-xl">
            Every client works directly with me.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <span className="mt-12 mb-5 block text-xs uppercase tracking-[0.2em] text-white/40" data-testid="closing-roster-note">
            Limited roster · By application
          </span>
          <button
            onClick={() => navigate("/apply")}
            data-testid="closing-apply-btn"
            className="group relative overflow-hidden rounded-full bg-white px-14 py-5 text-base uppercase tracking-[0.18em] text-black font-semibold shadow-[0_0_70px_-15px_rgba(255,255,255,0.5)]"
          >
            <span className="relative z-10 flex items-center gap-3">
              Apply Now
              <span className="inline-block transition-transform duration-300 group-hover:translate-x-1.5">→</span>
            </span>
            <span className="absolute inset-0 bg-white/0 transition-colors duration-300 group-hover:bg-white/90" />
          </button>
        </Reveal>
      </div>
    </section>
  );
};
